import React, { Component } from 'react';
import OLOverLay from 'ol/overlay';

class OverLay extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { mapInstance, position, positioning } = this.props;

    this.overlay = new OLOverLay({
      element: this.refs.overlay,
      offset: [-150, -10]
    });
    this.overlay.setPosition(position);
    this.overlay.setPositioning('bottom-left');
    mapInstance.addOverlay(this.overlay);
  }

  componentWillUnmount() {
    this.props.mapInstance.removeOverlay(this.overlay);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.position !== nextProps.position) {
      this.overlay.setPosition(nextProps.position);
    }
  }

  render() {
    const { children, style } = this.props;

    return (
      <div ref="overlay" style={style}>
        {children}
      </div>
    )
  }
}

export default OverLay;



// WEBPACK FOOTER //
// ./src/components/ol/OverLay.js